import CLUBS from './clubs.services';

const SERVICES = {
	CLUBS
};

export default SERVICES;
